// extracted by mini-css-extract-plugin
module.exports = {"recaptchaContainer":"delete-account_recaptchaContainer__N79Wz"};